import { render } from "./TypewriterText.vue?vue&type=template&id=649ffb8a&scoped=true"
import script from "./TypewriterText.vue?vue&type=script&lang=js"
export * from "./TypewriterText.vue?vue&type=script&lang=js"

import "./TypewriterText.vue?vue&type=style&index=0&id=649ffb8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649ffb8a"]])

export default __exports__